import Swal from 'sweetalert2'
import { useListView } from '../../core/ListViewProvider'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { Button, TableSelectionBar, useToast } from '../../../../../../components'
import { showAlertLoading, showError } from '../../../../../../../_metronic/helpers'
import { signAvaliacao, signAvaliacaoLote } from '../../core/_requests'
import {
  FormularioAtendimentoDtoAssinaturaLote,
  FormularioAtendimentoDtoAssinatura,
} from '../../core/_models'
import { useCertificado } from '../../../../../../helpers/hooks/useCertificado'

export const AvaliacoesPendentesListGrouping = () => {
  const { ensurePassword } = useCertificado()
  const { selected, clearSelected } = useListView()
  const { refetch } = useQueryResponse()
  const { showToast } = useToast()
  const count = selected.length

  // A senha do certificado já é a confirmação da assinatura (ensurePassword).
  const handleAssinar = async () => {
    try {
      const { ok, tipo } = await ensurePassword()
      if (!ok || !tipo) return

      showAlertLoading()
      if (count > 1) {
        const lote: FormularioAtendimentoDtoAssinaturaLote = {
          formulariosAtendimento: selected.map((item) => Number(item.formularioAtendimentoId)),
          tipo,
        }
        await signAvaliacaoLote(lote)
      } else {
        const unica: FormularioAtendimentoDtoAssinatura = {
          atendimento: Number(selected[0].atendimentoId),
          formularioAtendimento: Number(selected[0].formularioAtendimentoId),
          tipo,
        }
        await signAvaliacao(unica)
      }
      Swal.close()

      showToast({
        variant: 'success',
        title: count === 1 ? '1 avaliação assinada.' : `${count} avaliações assinadas.`,
      })
      // Assinadas saem da lista de pendentes.
      clearSelected()
      refetch()
    } catch (error) {
      showError(error)
      refetch()
    }
  }

  return (
    <TableSelectionBar count={count} onClear={clearSelected}>
      <Button className='btn-primary' onClick={handleAssinar}>
        {count === 1 ? 'Assinar avaliação' : 'Assinar avaliações'}
      </Button>
    </TableSelectionBar>
  )
}
